import { Tag } from 'antd';
import React from 'react';
import { Icon } from 'shared/components/Icon';
import './style.less';

export const TourBanner: React.FC = () => {
  return (
    <div className="TourBanner">
      <Tag className="TourBanner__tag">
        <Icon icon="monitor" />
        <span>Live Demo</span>
      </Tag>
      <p className="TourBanner__desc">
        This is a live demo version of Rep.ai. Complete all of the steps to exit this
        experience.
      </p>
      <div className="TourBanner__progress" id="TourBanner__progress"></div>
    </div>
  );
};
